import script from "./BaseFixedAside.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFixedAside.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFixedAside.vue?vue&type=style&index=0&id=16e2a8d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e2a8d2"]])

export default __exports__